import {faArrowUpRightFromSquare} from '@fortawesome/free-solid-svg-icons'
import {useSafeTranslation} from '@freckle/educator-materials/ts/helpers/translate'
import {SafeTrans} from '@freckle/educator-materials/ts/helpers/translate/component'
import {Link} from '../link'
import {footerMain, footerWrap, footerText} from './footer.module.scss'

export function AuthenticatedFooter() {
  const {t} = useSafeTranslation()
  const systemStatusLink = 'https://techcheck.freckle.com'
  const year = new Date().getFullYear()

  return (
    <div className={`${footerMain} hidden-print`}>
      <div className={footerWrap}>
        <p className={footerText}>
          <SafeTrans i18nKey="FOOTER_FRECKLE_TEXT" />
        </p>
        <p className={footerText}>
          &copy; <SafeTrans i18nKey="FOOTER_RIGHT_RESERVED" values={{year}} />
        </p>
        <Link
          href={systemStatusLink}
          target="_blank"
          reactRouter={false}
          leftIcon={faArrowUpRightFromSquare}
        >
          {t('FOOTER_SYSTEM_STATUS_TEXT')}
        </Link>
      </div>
    </div>
  )
}
